import { Grid } from '@mui/material'

import FormikAddress from '../formik-address'
import FormikTextField from '../formik-textfield'

const AddressForm = ({ fullWidth, hideAddress2 }: { fullWidth?: boolean; hideAddress2?: boolean }) => (
  <Grid container={true} columnSpacing={1} size={{ md: 12, lg: fullWidth ? 12 : 8 }}>
    <Grid size={12}>
      <FormikAddress />
    </Grid>

    {!hideAddress2 && (
      <>
        <Grid size={{ xs: 12, lg: 6 }}>
          <FormikTextField label="" name="address2" placeholder="Apt, Suite, etc (optional)" className="fs-exclude" />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>{/* nothing, taking up blank space */}</Grid>
      </>
    )}

    <Grid size={{ xs: 12, lg: 6 }}>
      <FormikTextField label="Country" name="country" className="fs-exclude" />
    </Grid>

    <Grid size={{ xs: 12, lg: 6 }}>{/* nothing, taking up blank space */}</Grid>

    <Grid size={{ xs: 12, md: 6 }}>
      <FormikTextField label="City" name="locality" className="fs-exclude" />
    </Grid>

    <Grid size={{ xs: 4, md: 2 }}>
      <FormikTextField label="State" name="region" className="fs-exclude" />
    </Grid>

    <Grid size={{ xs: 8, md: 4 }}>
      <FormikTextField label="ZIP/Postcode" name="code" className="fs-exclude" />
    </Grid>
  </Grid>
)

export default AddressForm
